export const queryParamAsArray = (
  value: string | string[] | null | undefined,
): string[] => {
  if (!value) return []
  return Array.isArray(value) ? value : [value]
}

export const queryParamAsString = (
  value: string | string[] | null | undefined,
): string | undefined => {
  if (!value) return undefined
  return Array.isArray(value) ? value[0] : value
}
